import React from 'react';
import {Link} from 'react-router';
import {DoiTuongKienNghiView} from 'modules/thanh-tra/sub-view';
import {Dialog} from "@blueprintjs/core";

class RowItemDoiTuongThanhTraView extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false
    }
  }

  closeDialog() {
    this.setState({
      isOpen: false
    })
  }

  handleView() {
    this.setState({
      isOpen: true
    })
  }

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.ten ? this.props.item.ten : ''}</td>
        <td>{this.props.item.trangThaiDoiTuongViPhamInfo ? this.props.item.trangThaiDoiTuongViPhamInfo.text : ''}</td>
        <td>
          <div className="todo-wrap two-item">
            <div className="wrap-link-todo">
              <Link className="text-13 txt-blue" onClick={this.handleView.bind(this)}>Xem chi tiết</Link>
            </div>
            <Dialog
              isOpen={this.state.isOpen}
              onClose={this.closeDialog.bind(this)}
              title='Chi tiết đối tượng vi phạm'
              className="dialog-default wrap-block">
                <DoiTuongKienNghiView id={this.props.item.doiTuongViPhamId} closeDialog={this.closeDialog.bind(this)} chucNangCuocThanhTra={this.props.chucNangCuocThanhTra} linhVucThanhTra={this.props.linhVucThanhTra}/>
            </Dialog>
          </div>
        </td>
      </tr>
    );
  }
}


RowItemDoiTuongThanhTraView.defaultProps = {
  handleEdit: function() {
    console.log('Need append handleEdit menthod');
  }
}

export default RowItemDoiTuongThanhTraView;


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemDoiTuongThanhTraView.jsx